"use strict";

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validator = exports.liskSchemaIdentifier = void 0;

var ajv_1 = require("ajv");

var ajv_formats_1 = require("ajv-formats");

var formats = require("./formats");

var errors_1 = require("./errors");

var field_number_1 = require("./keywords/field_number");

var data_type_1 = require("./keywords/data_type");

var lisk_meta_schema_1 = require("./lisk_meta_schema");

exports.liskSchemaIdentifier = lisk_meta_schema_1.liskMetaSchema.$id;

var LiskValidator = /*#__PURE__*/function () {
  function LiskValidator() {
    _classCallCheck(this, LiskValidator);

    this._validator = new ajv_1.default({
      strict: true,
      strictSchema: true,
      allErrors: true,
      useDefaults: false,
      addUsedSchema: false,
      strictTypes: false
    });
    ajv_formats_1.default(this._validator);

    for (var _i = 0, _Object$keys = Object.keys(formats); _i < _Object$keys.length; _i++) {
      var formatName = _Object$keys[_i];

      this._validator.addFormat(formatName, formats[formatName]);
    }

    this._validator.addKeyword({
      keyword: 'uniqueSignedPublicKeys',
      type: 'array',
      compile: function compile() {
        return function (data) {
          return new Set(data.filter(function (datum) {
            return typeof datum === 'string';
          }).map(function (key) {
            return key.slice(1);
          })).size === data.length;
        };
      }
    });

    this._validator.compile(lisk_meta_schema_1.liskMetaSchema);

    this._validator.addMetaSchema(lisk_meta_schema_1.liskMetaSchema);

    this._validator.addKeyword(field_number_1.fieldNumberKeyword);

    this._validator.addKeyword(data_type_1.dataTypeKeyword);
  }

  _createClass(LiskValidator, [{
    key: "validate",
    value: function validate(schema, data) {
      if (!this._validator.validate(schema, data)) {
        return errors_1.convertErrorsToLegacyFormat(this._validator.errors);
      }

      return [];
    }
  }, {
    key: "validateSchema",
    value: function validateSchema(schema) {
      if (!this._validator.validateSchema(schema)) {
        return errors_1.convertErrorsToLegacyFormat(this._validator.errors);
      }

      return [];
    }
  }, {
    key: "compile",
    value: function compile(schema) {
      try {
        return this._validator.compile(schema);
      } catch (error) {
        if (error instanceof errors_1.LiskValidationError) {
          throw error;
        }

        throw new errors_1.LiskValidationError([{
          message: error.message.toString(),
          dataPath: '',
          keyword: '',
          schemaPath: '',
          params: {}
        }]);
      }
    }
  }, {
    key: "removeSchema",
    value: function removeSchema(schemaKeyRef) {
      return this._validator.removeSchema(schemaKeyRef);
    }
  }]);

  return LiskValidator;
}();

exports.validator = new LiskValidator();